// import { useAuthStore } from '../store/authStore'
import useLetsDialAPI from './letsDialAPI/useLetsDialAPI'
import {
  routes,
  idleTabs,
  LetsDialManager,
  leadTabs,
  registeredPlugins,
  inboundTabs,
  menuItems,
  permissions,
} from '@letsdial/app/lib/index'
// const devModules = import.meta.glob('../../dev/**/index.ts')
import {
  init,
  loadRemote,
  loadShare,
  registerRemotes,
} from '@module-federation/enhanced/runtime'
import * as Vue from 'vue'
import { useAuthStore } from '../store/authStore'
export function useLetsDialExtensions() {
  const api = useLetsDialAPI()
  const authStore = useAuthStore()
  // const mount = async () => {
  //   // init({ name: '@letsdial/main' })
  // }
  const mount = async () => {
    const pluginResponse = await api.plugins.list({
      filter: { organizationId: authStore.selectedOrganization?.id },
    })
    if (pluginResponse.data) {
      console.log(`EXTENSION MANAGER: Starting Mount`)
      let extensions: { name: string; entry: string }[] = []
      if (import.meta.env.VITE_PLUGIN_DEV) {
        const devExtensions = import.meta.env.VITE_PLUGIN_DEV.split(',')
        for (const extension of devExtensions) {
          const [extensionName, extensionPath] = extension.split('|')
          extensions.push({
            name: extensionName,
            entry: `${extensionPath}/mf-manifest.json`,
          })
        }
      } else {
        pluginResponse.data = pluginResponse.data.filter(
          (plugin) => plugin.attributes.enabled === true,
        )

        extensions = pluginResponse.data.map((plugin) => {
          return {
            name: plugin.attributes.name,
            entry: `${import.meta.env.VITE_APPS_URL || 'https://apps.letsdial.co.za'}/apps/${plugin.attributes.name}/mf-manifest.json`,
          }
        })
      }

      init({
        name: '@letsdial/main',
        shared: {
          vue: {
            version: '3.4.14',
            scope: 'default',
            lib: () => Vue,
            shareConfig: { singleton: true, requiredVersion: '^3.4.14' },
          },
        },
        remotes: [],
      })

      await loadShare('vue')

      for (const extension of extensions) {
        try {
          registerRemotes([
            {
              name: extension.name,
              entry: extension.entry,
            },
          ])
          console.log(`EXTENSION MANAGER:`, extension)
          await loadShare('vue', '3.4.14')
          const loaded = await loadRemote(`${extension.name}/init`)
          console.log(`EXTENSION MANAGER:`, loaded)
          // @ts-expect-error: Intentional ignore
          loaded.init(LetsDialManager)

          console.log(`Loaded extension: ${extension.name}`)
        } catch (err) {
          console.warn(`Failed to load extension ${extension.name}:`, err)
        }
      }
    }
  }
  const unMount = () => {
    // idleTabs.value = []
    // leadTabs.value = []
    // inboundTabs.value = []
    // disableWrapOnCallEnd.value = false
  }
  return {
    routes,
    idleTabs,
    leadTabs,
    inboundTabs,
    menuItems,
    registeredPlugins,
    mount,
    unMount,
    disableWrapOnCallEnd: Vue.ref(false),
    permissions,
  }
  return { mount }
}
